import React from "react";
import Row from "@visa/vds/row";
import Col from "@visa/vds/col";
import OrderInformation from 'pages/Admin/Subscription/Components/OrderInformation';
import OrderNotesPanel from './OrderNotesPanel';
import OrderOrganizationDetails from './OrderOrganizationDetails';

const OrderReferenceAccordionBody = (props) => {
    let { order, showOrderNotes } = props
    return (
        <>
            <Row>
                <Col xs={4} sm={4} md={4} lg={6}>
                    <OrderInformation order={order} />
                </Col>
                <Col xs={4} sm={4} md={4} lg={6}>
                    <OrderOrganizationDetails licensedBusinessPaymentInformation={order.licensedBusinessPaymentInformation} />
                </Col>
            </Row>
            {showOrderNotes &&
                <Row>
                    <Col>
                        <OrderNotesPanel notes={order.notes} readOnly={true} />
                    </Col>
                </Row>
            }
        </>
    );
}
export default OrderReferenceAccordionBody;